module.exports = __webpack_public_path__ + "img/Prosedur-dan-Cara-Bertransaksi.dc1f4e96.jpg";